
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Role } from "@/hooks/rollenbeheer/types";

interface RoleBadgeProps {
  role: Role;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role }) => {
  switch (role) {
    case "medewerker":
      return <Badge variant="outline" className="bg-blue-50">Medewerker</Badge>;
    case "planner":
      return <Badge variant="outline" className="bg-green-50">Planner</Badge>;
    case "management":
      return <Badge variant="outline" className="bg-purple-50">Management</Badge>;
    default:
      return <Badge variant="outline">{role}</Badge>;
  }
};

export default RoleBadge;
